import React, {ReactElement} from "react"
import {AllowedWalletsTermsColumns, WalletsTermsColumns} from "./WalletTerms.types"
import {WalletTerms} from "../../resources/walletTerms"
import {Resource} from "../../resources/common"
import {useNavigate} from "react-router-dom"
import {DataTableCell, DataTableRow} from "../DataTable/DataTable"
import classNames from "classnames"
import {OrgName} from "../OrgName/OrgName"
import {BankName} from "../BankName/BankName"
import moment from "moment"
import IdLink from "../IdLink/IdLink"

interface WalletsTermsRowProps {
	walletTerms: WalletTerms
	include?: Resource[]
	showOrgColumn?: boolean
	includedColumns: Array<AllowedWalletsTermsColumns>
	refresh?: () => void
}

export default function WalletTermsRow({walletTerms, include, includedColumns}: WalletsTermsRowProps) {
	const navigate = useNavigate()

	const contentColumns: Partial<Record<AllowedWalletsTermsColumns, ReactElement>> = {}

	if (includedColumns.includes(WalletsTermsColumns.id)) {
		contentColumns["Id"] = (
			<DataTableCell className={classNames("data-table-id-cell")}>
				<IdLink className="data-table-id" href={`/wallet-terms/${walletTerms.id}`}>
					{walletTerms.id}
				</IdLink>
			</DataTableCell>
		)
	}

	if (includedColumns.includes(WalletsTermsColumns.status) && walletTerms.attributes.status == "Disabled") {
		contentColumns["Status"] = (
			<DataTableCell>
				<div className="wallets-terms-status"> {walletTerms.attributes.status} </div>
			</DataTableCell>
		)
	} else {
		contentColumns["Status"] = <DataTableCell> </DataTableCell>
	}

	if (includedColumns.includes(WalletsTermsColumns.org)) {
		if (walletTerms?.relationships?.org) {
			contentColumns["Org"] = <OrgName orgId={walletTerms.relationships.org.data.id} included={include} />
		} else {
			contentColumns["Org"] = <DataTableCell> -- </DataTableCell>
		}
	}

	if (includedColumns.includes(WalletsTermsColumns.name)) {
		contentColumns["Name"] = <DataTableCell>{walletTerms.attributes.name}</DataTableCell>
	}

	if (includedColumns.includes(WalletsTermsColumns.bank)) {
		if (walletTerms?.relationships?.bank) {
			contentColumns["Bank"] = (
				<DataTableCell>
					<BankName bankId={walletTerms.relationships.bank.data.id} included={include} />
				</DataTableCell>
			)
		} else if (walletTerms.attributes.bankName) {
			contentColumns["Bank"] = <DataTableCell>{walletTerms.attributes.bankName}</DataTableCell>
		} else {
			contentColumns["Bank"] = <DataTableCell> -- </DataTableCell>
		}
	}

	if (includedColumns.includes(WalletsTermsColumns.createdAt)) {
		contentColumns["Created At"] = <DataTableCell>{moment(walletTerms.attributes.createdAt).format("L")}</DataTableCell>
	}

	const content: Array<ReactElement | null> = []

	includedColumns.forEach((col, i) => {
		if (col in contentColumns && contentColumns[col]) {
			const column = {...contentColumns[col]} as ReactElement
			column.key = i.toString()
			content.push(column)
		}
	})

	return (
		<DataTableRow
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
				navigate(`/wallet-terms/${walletTerms.id}`)
			}}
		>
			{content}
		</DataTableRow>
	)
}
